import { Grid, useTheme, Stack, RichTextReader, Typography, Card } from "@compass/core";
import { Application } from "generated/openApi";
import { useEffect } from "react";

type publicApplicationSubmissionProps = {
  application: Application;
};

export const PublicApplicationSubmission = ({ application }: publicApplicationSubmissionProps) => {
  const theme = useTheme();

  useEffect(() => {}, []);

  return (
    <Card sx={{ maxWidth: "1000px", width: "100%" }}>
      <Stack px={3} py={7} spacing="lg" width="100%">
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <Typography variant="h4">{application.title}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2">{application.subTitle}</Typography>
          </Grid>

          <Grid item xs={12}>
            <RichTextReader html={application.submitMessage} />
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
